import { TextField } from "@mui/material";
import React, { useState } from "react";

import Button from "../../components/buttons/Button";
import "../../styles/customer/CustomerInfoView.css";
import { useSnackbar } from "notistack";
import { CreateCustomer } from "../../hooks/useCustomerData";

export const CreateCustomerModal = (props) => {
  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState("");
  const [municipality, setMunicipality] = useState("");

  const createCustomerMutation = CreateCustomer({
    onSuccess: () => {
      enqueueSnackbar("Organisation skapad.", { variant: "success" });
      props.closeCreateModal && props.closeCreateModal();
    },
    onError: (error) => {
      console.log("🚀 ~ CreateCustomer ~ error:", error);
      enqueueSnackbar("Kunde inte skapa organisation.", { variant: "error" });
    },
  });

  const handleCreate = () => {
    if (!name.trim() || !municipality.trim()) {
      enqueueSnackbar("Fyll i alla fält.", { variant: "error" });
      return;
    }

    createCustomerMutation.mutate({
      organisation_name: name.trim(),
      municipality: municipality.trim(),
    });
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleCreate();
      }}
      className="container"
      style={{ width: "100%", gap: "1em" }}
    >
      <div
        className="form-grid-auto"
        style={{ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}
      >
        <TextField
          required
          label="Namn på organisation"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          required
          label="Kommun"
          value={municipality}
          onChange={(e) => setMunicipality(e.target.value)}
        />
      </div>

      <div className="rightAlign-button-container">
        <Button
          type="submit"
          color="success"
          disabled={createCustomerMutation.isLoading}
        >
          Spara
        </Button>
        <Button variant="outlined" onClick={() => props.closeCreateModal()}>
          Stäng
        </Button>
      </div>
    </form>
  );
};
